import { Command } from 'commander';
import { getV2Client } from '../../api/v2-client.js';
import type { IV2Client } from '../../api/v2-client.js';
import { handleV2Error } from '../../handle-error.js';
import { Output } from '../../output.js';
import { addGridOption, gridSlug, type GridOpts } from '../../grid-opt.js';

interface MembersOpts extends GridOpts { json?: boolean; }

export async function runAdminMembers(opts: MembersOpts, client?: IV2Client): Promise<void> {
  const out = Output.fromOpts({ json: !!opts.json, quiet: false });
  const c = client ?? await getV2Client(gridSlug(opts));
  const resp = await c.get<{ members: Array<{ user_id: string; name: string; email: string; role: string; slug: string; joined_at: string }> }>('/api/v2/members');
  out.json(() => resp.members);
  out.human(() => {
    if (resp.members.length === 0) return 'No members.';
    const lines = [`Members (${resp.members.length}):`];
    for (const m of resp.members) {
      lines.push(`  - ${m.name} (${m.email}) — ${m.role} — joined ${m.joined_at}`);
    }
    return lines.join('\n');
  });
}

export const adminMembersCommand = new Command('members')
  .description('List grid members (admin only)')
  .option('--json', 'JSON output');
addGridOption(adminMembersCommand, 'Override active grid');
adminMembersCommand
  .action(async (opts: MembersOpts) => {
    try { await runAdminMembers(opts); }
    catch (err) { await handleV2Error(err, { json: !!opts.json }); }
  });
